module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAABIElEQVQoU51SQU6DQBR9f/AAkKCBdc9hKiZs2OoRVIK9BJeoZNAb2DMQky5gwRUg3UHVRQ8gfDNjaGgtm85q5s17//0/8wijlSTJDREtiOgawCWAL2ZeM/MyiqKPgUpqE8fxheu6SwCPADR2tBjAa9M0iziOfzRBSikBPJ0gH0NpGIYhqZaEENmEwz/Hvu9vKU3Td2a+n3KxLAuz2QxlWWoKEa1ISrkFcKUARdjtdmBWI/ydgyBAnueo63qou1WiDoBQiOd5EEIgyzKYpqkFRVGgqqpxI92Bk2EY8H1fO9m2fUqg7j6VaAXgbiilhPP5HJvNZtzS3knPdNbrnfVPQyIcx3khooepRDDzW9u2z/tEDA0fZc8G8E1E667rDrL3C42FhTWgXPocAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/xuanzhong_normal_icon.png
// module id = Axmd
// module chunks = 1